"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolEchainUtils = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const Zubehoer_1 = require("../zubehoer/Zubehoer");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const RolEchainCalculatorFactory_1 = require("./RolEchainCalculatorFactory");
const Kette_1 = require("../kette/Kette");
const A_1 = require("../A");
class RolEchainUtils {
    static getLangerWegZeichnungsnummer(rolEchain) {
        var _a, _b;
        const langerWegZeichnungsnummer = (_b = (_a = rolEchain === null || rolEchain === void 0 ? void 0 : rolEchain.Serie) === null || _a === void 0 ? void 0 : _a.LangerWegZeichnungsnummer) !== null && _b !== void 0 ? _b : rolEchain.LangerWegZeichnungsnummer;
        if (!langerWegZeichnungsnummer) {
            throw new Error(`${this.className}.getLangerWegZeichnungsnummer() langerWegZeichnungsnummer is missing`);
        }
        return langerWegZeichnungsnummer;
    }
    static setColor(rolEchain, indexColor = '0') {
        rolEchain.Color = rolEchain.RolLink.Color = rolEchain.StandardLink.Color = indexColor;
        if (rolEchain.AdapterLink) {
            rolEchain.AdapterLink.Color = indexColor;
        }
        if (rolEchain.ModifiedLink) {
            rolEchain.ModifiedLink.Color = indexColor;
        }
        if (rolEchain.AutoglideLink) {
            rolEchain.AutoglideLink.Color = indexColor;
        }
    }
    static setMaterial(rolEchain, material) {
        rolEchain.Material = rolEchain.RolLink.Material = rolEchain.StandardLink.Material = material;
        if (rolEchain.AdapterLink) {
            rolEchain.AdapterLink.Material = material;
        }
        if (rolEchain.ModifiedLink) {
            rolEchain.ModifiedLink.Material = material;
        }
        if (rolEchain.AutoglideLink) {
            rolEchain.AutoglideLink.Material = material;
        }
    }
    static setArtNrGenerated(rolEchain, localeService, indexColor, material) {
        rolEchain.ArtNrGenerated = rolEchain.RolLink.ArtNrGenerated = this.generateArtNrGenerated(rolEchain.RolLink, localeService, indexColor, material);
        rolEchain.StandardLink.ArtNrGenerated = this.generateArtNrGenerated(rolEchain.StandardLink, localeService, indexColor, material);
        if (rolEchain.AdapterLink) {
            rolEchain.AdapterLink.ArtNrGenerated = this.generateArtNrGenerated(rolEchain.AdapterLink, localeService, indexColor, material);
        }
        if (rolEchain.ModifiedLink) {
            rolEchain.ModifiedLink.ArtNrGenerated = this.generateArtNrGenerated(rolEchain.ModifiedLink, localeService, indexColor, material);
        }
        if (rolEchain.AutoglideLink) {
            rolEchain.AutoglideLink.ArtNrGenerated = this.generateArtNrGenerated(rolEchain.AutoglideLink, localeService, indexColor, material);
        }
        return this.setArtNrExists(rolEchain);
    }
    /**
     * returns artNr, description, count of per rolEchain item
     * the order in the array represents the order for the part lists
     */
    static getPartListParts(rolEchain, localeService) {
        if (!(0, echain_shared_articles_1.isCalculateableRolEchain)(rolEchain))
            return [];
        const partListPartArray = [];
        const calculator = RolEchainCalculatorFactory_1.RolEchainCalculatorFactory.getCalculator(rolEchain);
        const linkCounts = calculator.calcNumLinksByType(rolEchain);
        // 1. RolLink
        partListPartArray.push(this.createPartListPart(rolEchain.RolLink, linkCounts.numRolLinks, localeService));
        // 2. Lubricating grease if exists
        const grease = rolEchain.Serie.Grease;
        if (grease) {
            const greaseArticle = Zubehoer_1.Zubehoer.fromScratch().toModel();
            greaseArticle.Bezeichnung = grease.Description;
            greaseArticle.ArtNr = grease.ArtNr;
            greaseArticle.ArtNrGenerated = localeService.getArtNr(grease.ArtNr);
            greaseArticle.ArtNrExists = true;
            greaseArticle.ArticleSpecs = [echain_shared_articles_1.ArticleSpecs.rolEchainGrease];
            partListPartArray.push(this.createPartListPart(greaseArticle, 1, localeService));
        }
        // 3a. AdapterLink if exists
        if ((0, echain_shared_articles_1.isRolEchainWithAdapterLinkUnsafe)(rolEchain)) {
            partListPartArray.push(this.createPartListPart(rolEchain.AdapterLink, linkCounts.numAdapterLinks, localeService));
        }
        // 3b. ModifiedLink if exists
        if ((0, echain_shared_articles_1.isRolEchainWithModifiedLinkUnsafe)(rolEchain)) {
            partListPartArray.push(this.createPartListPart(rolEchain.ModifiedLink, linkCounts.numModifiedLinks, localeService));
        }
        // 3c. AutoglideLink if exists
        if ((0, echain_shared_articles_1.isRolEchainWithAutoglideLinkUnsafe)(rolEchain)) {
            partListPartArray.push(this.createPartListPart(rolEchain.AutoglideLink, linkCounts.numAutoglideLinks, localeService));
        }
        // 4. StandardLink
        partListPartArray.push(this.createPartListPart(rolEchain.StandardLink, linkCounts.numStandardLinks, localeService));
        return partListPartArray;
    }
    static createPartListPart(article, articleCount, localeService) {
        const linkArtNrGenerated = article.ArtNrGenerated;
        const linkDescription = localeService.getUserArticleLocalizedText(article.Bezeichnung);
        if (!linkArtNrGenerated) {
            throw new Error(`${this.className}.getPartListPart(): undefined ArtNrGenerated on link with id ${article.Id}`);
        }
        if (!linkDescription) {
            throw new Error(`${this.className}.getPartListPart(): undefined Description on link with id ${article.Id}`);
        }
        return {
            ArtNr: linkArtNrGenerated,
            Description: linkDescription,
            ArticleCount: articleCount,
            Article: article,
        };
    }
    static setArtNrExists(rolEchain) {
        rolEchain.ArtNrExists = true;
        rolEchain.RolLink.ArtNrExists = true;
        rolEchain.StandardLink.ArtNrExists = true;
        if (rolEchain.AdapterLink) {
            rolEchain.AdapterLink.ArtNrExists = true;
        }
        if (rolEchain.ModifiedLink) {
            rolEchain.ModifiedLink.ArtNrExists = true;
        }
        if (rolEchain.AutoglideLink) {
            rolEchain.AutoglideLink.ArtNrExists = true;
        }
        return rolEchain;
    }
    static generateArtNrGenerated(link, localeService, indexColor, material) {
        let ketteArtNrGenerated = localeService.getArtNr(link.ArtNr);
        const seperator = localeService.getArtNrSeparator();
        if (!ketteArtNrGenerated) {
            throw new Error(`${this.className}.generateArtNrGenerated() ArtNr is missing for kette ${link}`);
        }
        if (material) {
            ketteArtNrGenerated = ketteArtNrGenerated + seperator + material;
        }
        if (indexColor && indexColor !== '0') {
            ketteArtNrGenerated = ketteArtNrGenerated === null || ketteArtNrGenerated === void 0 ? void 0 : ketteArtNrGenerated.replace(`${seperator}0${seperator}`, `${seperator}${indexColor}${seperator}`);
        }
        return ketteArtNrGenerated;
    }
    static getLinkForIaFilling(kette) {
        return kette.StandardLink;
    }
    static getVerpackungCalculationValues(rolEchain, aes) {
        const calculator = RolEchainCalculatorFactory_1.RolEchainCalculatorFactory.getCalculator(rolEchain);
        return {
            ketteBiegeradius_mm: (0, echain_shared_quantities_1.Q)(rolEchain.Biegeradius).mm,
            ketteAussenbreite_mm: (0, echain_shared_quantities_1.Q)(rolEchain.Aussenbreite).mm,
            ketteAussenhoehe_mm: (0, echain_shared_quantities_1.Q)(rolEchain.Aussenhoehe).mm,
            ketteEffektiveLaenge_mm: calculator.calcLaengeWithAEs(rolEchain, aes).mm,
        };
    }
    static convertLinkToKette(linkUnion, rolEchainPart) {
        const ketteModel = Kette_1.Kette.fromScratch().toModel();
        ketteModel.ArtNr = linkUnion.ArtNr;
        ketteModel.Id = linkUnion.Id;
        ketteModel.ArtNrGenerated = linkUnion.ArtNrGenerated;
        ketteModel.ArtNrExists = linkUnion.ArtNrExists;
        ketteModel.Aussenbreite = linkUnion.Aussenbreite;
        ketteModel.Aussenhoehe = linkUnion.Aussenhoehe;
        ketteModel.BestTyp = linkUnion.BestTyp;
        ketteModel.Bezeichnung = linkUnion.Bezeichnung;
        ketteModel.Biegeradius = linkUnion.Biegeradius;
        ketteModel.GleitenderBetriebErlaubt = linkUnion.GleitenderBetriebErlaubt;
        ketteModel.FreigabeEIC = linkUnion.FreigabeEIC;
        ketteModel.FreigabeEKE = linkUnion.FreigabeEKE;
        ketteModel.FreigabeEKEManualMode = linkUnion.FreigabeEKEManualMode;
        ketteModel.IndexBreite = linkUnion.IndexBreite;
        ketteModel.IndexBiegeradius = linkUnion.IndexBiegeradius;
        ketteModel.Innenbreite = linkUnion.Innenbreite;
        ketteModel.Innenhoehe = linkUnion.Innenhoehe;
        ketteModel.K2 = linkUnion.K2;
        ketteModel.MinDistKlemmO = linkUnion.MinDistKlemmO || ketteModel.MinDistKlemmO;
        ketteModel.MinDistKlemmU = linkUnion.MinDistKlemmU || ketteModel.MinDistKlemmU;
        ketteModel.MinDistO = linkUnion.MinDistO || ketteModel.MinDistO;
        ketteModel.MinDistU = linkUnion.MinDistU || ketteModel.MinDistU;
        ketteModel.RastPosDist = linkUnion.RastPosDist || ketteModel.RastPosDist;
        ketteModel.RastPosLeft = linkUnion.RastPosLeft || ketteModel.RastPosLeft;
        ketteModel.UngeradeAnzahlGlieder = linkUnion.UngeradeAnzahlGlieder;
        ketteModel.VersatzFestpunktErlaubt = linkUnion.VersatzFestpunktErlaubt;
        ketteModel.Teilung = linkUnion.Teilung;
        ketteModel.SerieRef = linkUnion.SerieRef;
        if ((0, echain_shared_articles_1.isRolLinkUnsafe)(linkUnion) ||
            (0, echain_shared_articles_1.isRolAdapterLinkUnsafe)(linkUnion) ||
            (0, echain_shared_articles_1.isRolModifiedLinkUnsafe)(linkUnion) ||
            (0, echain_shared_articles_1.isRolAutoglideLinkUnsafe)(linkUnion)) {
            ketteModel.KetteSerieType = echain_shared_articles_1.KetteSerieType.rolEchain;
        }
        else if ((0, echain_shared_articles_1.isStandardLinkUnsafe)(linkUnion)) {
            ketteModel.KetteSerieType = echain_shared_articles_1.KetteSerieType.default;
        }
        else {
            (0, echain_shared_ts_utils_1.assertUnreachable)(linkUnion);
        }
        if (ketteModel.Teilung && rolEchainPart) {
            const pitch = (0, echain_shared_quantities_1.Q)(ketteModel.Teilung).mm || 0;
            ketteModel.NumGlieder = rolEchainPart.ArticleCount;
            ketteModel.Laenge = { Value: ketteModel.NumGlieder * pitch, Unit: 'mm' };
            ketteModel.EffektiveLaenge = ketteModel.Laenge;
        }
        return (0, A_1.A)(ketteModel);
    }
    static isRolEchainPart1(rolEchainPartName) {
        switch (rolEchainPartName) {
            case echain_shared_articles_1.RolEchainPartNames.Part1a:
            case echain_shared_articles_1.RolEchainPartNames.Part1b:
            case echain_shared_articles_1.RolEchainPartNames.Part1c:
            case echain_shared_articles_1.RolEchainPartNames.Part1d:
            case echain_shared_articles_1.RolEchainPartNames.Part1e:
                return true;
            case echain_shared_articles_1.RolEchainPartNames.Part2:
            case echain_shared_articles_1.RolEchainPartNames.Part3:
            case echain_shared_articles_1.RolEchainPartNames.Part4:
                return false;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(rolEchainPartName);
        }
    }
}
exports.RolEchainUtils = RolEchainUtils;
RolEchainUtils.className = 'RolEchainUtils';
//# sourceMappingURL=RolEchainUtils.js.map